export default __webpack_public_path__ + "static/media/regulatory--end-of-no-overtaking-by-motorcycles--g1.a23aae0c.png";